export default __webpack_public_path__ + "7c817e1df5b5f5fb2890421365d9c57e.png";